/**
 * SupplierNoteService
 * Service for Supplier Note entity operations
 * Route: api/suppliernotes
 */
import { CrudService } from '../base/CrudService';
/**
 * SupplierNoteService
 * Handles supplier note CRUD operations
 */
export class SupplierNoteService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SupplierNoteService.DEFAULT_SERVICE_PATH,
            basePath: SupplierNoteService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get notes by supplier ID
     * @param supplierId - Supplier ID
     * @returns Array of notes for the supplier
     */
    async getBySupplier(supplierId) {
        const response = await this.getBySupplierRaw(supplierId);
        return response.data ?? [];
    }
    /**
     * Get notes by supplier ID (raw)
     * @param supplierId - Supplier ID
     * @returns ResponseData with notes
     */
    getBySupplierRaw(supplierId) {
        const endpoint = this.getEndpoint('by-supplier', `by-supplier/${supplierId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
SupplierNoteService.DEFAULT_SERVICE_PATH = 'suppliers';
SupplierNoteService.BASE_PATH = 'api/suppliernotes';
//# sourceMappingURL=SupplierNoteService.js.map